import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useUser, useTalentMutation } from "../../actions/authActions";

export default () => { 
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(true);
  const [isOfScreen, setIsOfScreen] = useState();
  const [loadingToapi, setLoadingToapi] = useState(false);
  const [countryCode, setCountryCode] = useState(null);
  const [cca2, setCca2] = useState(null);
  const [currentStep, setCurrentStep] = useState(0);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [links, setLinks] = useState([]);
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const [linksErrors, setLinksErrors] = useState({ platform: "", links: {} });
  const userId = localStorage.getItem("userId");
  const {
    data: userprofile,
    isLoading: isLoadingprefilled,
    isError,
    error,
  } = useUser(userId);
  const dispatch = useDispatch();
  const [select, setSelect] = useState({
    gender: "",        // ✅ Changed from null to ""
    ethnicity: "",     // ✅ Changed from null to ""
    country: null,
    states: null,
    city: null,
    hairTypes: null,
    eyeColors: null,
    experienceLevel: null,
  });
  
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    control,
    clearErrors,
    trigger,  // ✅ ADD trigger
    formState: { errors },
  } = useForm({
    values: {
      full_name: userprofile?.first_name + " " + userprofile?.last_name || "",
    },
    defaultValues: {
      // ✅ ADDED ALL MISSING FIELDS
      stageName: "",
      full_name: userprofile?.first_name + " " + userprofile?.last_name || "",
      age: "",
      gender: "",              // ✅ CRITICAL - This was missing!
      ethnicity: "",           // ✅ CRITICAL - This was missing!
      agent_code: "",
      about_me: "",
      
      // Location
      city_id: userprofile?.city_id ? String(userprofile?.city_id) : "",
      countries: userprofile?.country_id ? String(userprofile?.country_id) : "",
      state_id: userprofile?.state_id ? String(userprofile?.state_id) : "",
      
      // Contact
      mobile_num: "",
      mobile_number: "",
      talentWebsite: "",
      
      // Physical Attributes
      hairTypes: "",
      height: "",
      weight: "",
      eyeColors: "",
      bodyTattoos: "",
      bodyPiercings: "",
      
      // Professional
      desiredJobType: [],
      experience: "",
      otherExperience: "",
      qualification: "",
      languagesSpoken: [],
      otherLanguage: "",
    },
  });
  
  useEffect(() => {
    if (
      !isLoadingprefilled &&
      userprofile &&
      Object.keys(userprofile).length > 0
    ) {
      setValue("mobile_num", userprofile?.mobile_num || "");
      setValue(
        "city_id",
        userprofile?.city_id ? String(userprofile?.city_id) : ""
      );
      setValue(
        "countries",
        userprofile?.country_id ? String(userprofile?.country_id) : ""
      );
      setValue(
        "state_id",
        userprofile?.state_id ? String(userprofile?.state_id) : ""
      );
    }
  }, [userprofile, isLoadingprefilled, setValue]);
  
  const talentId = false;
  const isLogin = true;
  const mutation = useTalentMutation(
    talentId,
    dispatch,
    setLoadingToapi,
    navigate,
    isLogin
  );
  
  const isValidUrl = (url) => {
    const pattern =
      /^https?:\/\/(www\.)?[\w\-]+\.(com|net|org|co|in|info|biz|me|us|uk)(\/[\w\-._~:/?#[\]@!$&'()*+,;=]*)?$/i;
    return pattern.test(url);
  };

  const validateBeforeSubmit = () => {
    const linkErrors = {};
    links.forEach((link) => {
      const trimmedUrl = link.url.trim();
      if (!trimmedUrl) {
        linkErrors[link.id] = `${link.platform} link is required.`;
      } else if (!isValidUrl(trimmedUrl)) {
        linkErrors[link.id] = `Please enter a valid ${link.platform}`;
      }
    });

    setLinksErrors({ links: linkErrors });
    return Object.keys(linkErrors).length === 0;
  };
  
  const otherExperienceId = watch("experience");
  const otherLanguageId = watch("languagesSpoken");
  
  const onSubmit = (data, e) => {
    e.preventDefault();
    if (Object.keys(errors).length > 0) {
      return; // Stop execution if there are errors
    }
    const isLinksValid = validateBeforeSubmit();
    if (!isLinksValid) {
      return; // Stop if social links are invalid
    }

    if (currentStep === steps.length - 1) {
      setLoadingToapi(true);
      const apiData = new FormData();
      apiData.append("stage_name", data?.stageName);
      apiData.append(
        "real_name",
        data.full_name || userprofile?.first_name + " " + userprofile?.last_name
      );
      apiData.append("age", data.age);
      apiData.append("gender", data.gender);
      apiData.append("ethinicity", data.ethnicity);
      apiData.append("city_id", data?.city_id || userprofile?.city_id);
      apiData.append("country_id", data.countries || userprofile?.country_id);
      apiData.append("country_code", countryCode || userprofile?.country_code);
      apiData.append('cca2', cca2 || userprofile?.cca2);  
      apiData.append("state_id", data?.state_id || userprofile?.state_id);
      apiData.append("mobile_number", data.mobile_number);
      if (
        data.talentWebsite !== null &&
        data.talentWebsite !== undefined &&
        data.talentWebsite !== "undefined"
      ) {
        apiData.append("your_website", data.talentWebsite);
      }
      if (isOfScreen === false) {
        apiData.append("hair_type", data.hairTypes);
        apiData.append("height", data.height);
        apiData.append("weight", data.weight);
        apiData.append("eye_colors", select?.eyeColors);
        apiData.append("bodyTattoos", data.bodyTattoos);
        apiData.append("bodyPiercings", data.bodyPiercings);
      }
      if (
        data.about_me !== null &&
        data.about_me !== undefined &&
        data.about_me !== "undefined"
      ) {
        apiData.append("about_me", data.about_me);
      }
      // apiData.append('sexual_orientation', data.sexualOrientations);
      data.desiredJobType.forEach((jobType) => {
        apiData.append("desired_job_types[]", Number(jobType));
      });
      apiData.append("experience_level", data.experience);
      if (data.experience == 52) {
        apiData.append("other_experience", data.otherExperience);
      }

      apiData.append("qualification", data?.qualification);
      if (Array.isArray(data.languagesSpoken)) {
        data.languagesSpoken.forEach((lang) => {
          apiData.append("language_spoken[]", lang);
        });
      } else if (data.languagesSpoken) {
        apiData.append("language_spoken[]", data.languagesSpoken);
      }
      apiData.append("other_language", data.otherLanguage);
      apiData.append("off_screen", isOfScreen ? 1 : 0);
      apiData.append("user_id", userId);
      if (
        data.agent_code !== null &&
        data.agent_code !== undefined &&
        data.agent_code !== "undefined"
      ) {
        apiData.append("agent_code", data.agent_code);
      }
      links.forEach((link) => {
        apiData.append("social_media_type[]", link.platform);
        apiData.append("social_media_link[]", link.url);
      });
      mutation.mutate(apiData);
      setCompletedSteps([]);
      setCurrentStep(0);
    } else {
      setCompletedSteps([...completedSteps, currentStep]);
      setCurrentStep((prev) => prev + 1);
      clearErrors();
    }
  };
  
  const steps = [
    "Personal Information",
    "Location Details",
    "Contact Information",
    // "Physical Attributes",
    "Professional Preferences",
  ];
  if (isOfScreen === false) {
    steps.splice(3, 0, "Physical Attributes");
  }
  
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading userprofile: {error.message}
        </p>
      </div>
    );
  }
  
  return {
    // stepper
    steps,
    currentStep,
    setCurrentStep,
    completedSteps,
    setCompletedSteps,

    // form
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    trigger,  // ✅ RETURN trigger
    errors,
    onSubmit,

    // links / socials
    links,
    setLinks,
    selectedPlatform,
    setSelectedPlatform,
    linksErrors,
    setLinksErrors,
    select,
    setSelect,

    // misc
    setCountryCode,
    countryCode,
    setCca2,
    cca2,
    isOfScreen,
    setIsOfScreen,
    otherLanguageId,
    otherExperienceId,

    // API
    loadingToapi,
    setLoadingToapi,

    // modal
    isModalOpen,
    setModalOpen,
  };
};